// extracted by mini-css-extract-plugin
export default {"ProductAnnouncementBannerAnimation":"ProductAnnouncementBannerAnimation-module__ProductAnnouncementBannerAnimation__LKbY9nT"};